// eslint-disable-next-line import/prefer-default-export
export function useMfaLabels() {
  const extraStep = 'This extra step proves your identity.';
  return {
    chooseDifferent: 'Choose A Different Way',
    or: 'OR',
    passwordResetHeader: 'User Password Reset',
    tryAgain: 'Try again',
    verifyIdentity: 'Verify Your Identity',
    chooser: {
      help: `${extraStep} Choose a verification method.`,
    },
    duo: {
      help: `${extraStep} You’ll need to verify yourself with Duo Security.`,
      error: {
        load: 'Unable to load Duo Web JavaScript file!',
        redirect: 'An error occurred while redirecting to Duo Security. Try again, or use an alternate verification option.',
        retrieve: 'Unable to retrieve Duo configuration!',
        verify: 'Unable to verify Duo. If this problem persists, contact your IT Admin.',
      },
      button: {
        disabled: 'Redirecting To Duo Security',
        enabled: 'Verify With Duo Security',
      },
    },
    push: {
      help: `${extraStep} We’ll send a push notification to your phone through JumpCloud Protect.`,
      button: {
        disabled: 'Request Sent. Approve It On Your Phone',
        enabled: 'Send Request To Phone',
      },
    },
    totp: {
      help: `${extraStep} You’ll need to use your registered authenticator app.`,
      label: 'Enter 6-digit code:',
    },
    sms_otp: {
      help: `${extraStep} We'll send a one-time passcode to your phone.`,
      label: 'Enter 6-digit code:',
      resendLink: 'Resend SMS',
      terminalNoInput:
        'No input received. Please try re-initiating the session again or Contact your IT administrator for assistance',
      sending: 'Sending…',
      error: {
        unknown: 'An unknown error occurred. Please try again.',
        pending: 'OTP is still being sent. Please wait.',
        expired: 'The verification code has expired. Please request a new code.',
        failed: 'Failed to send OTP. Please try again.',
        maxAttempts: 'Maximum verification attempts exceeded. Please try again later.',
        send: 'Failed to send OTP. Please try again.',
        tooManyFailedAttempts:
          'Too many failed SMS OTP attempts. For your security, please try a fresh login or contact your administrator for assistance.',
      },
    },
    webauthn: {
      help: `${extraStep} You’ll need your USB security key or device biometric (such as Touch ID or Windows Hello).`,
      login: 'Login with Security Key or Device Biometric',
      unsupported: 'Security Keys are not supported on this browser.',
    },
  };
}
